import styled from "styled-components";

export const QuizTabWrapper = styled.div`
  border-radius: 12px;

  form {
    .container-answer img {
      height: fit-content;
    }
    .label-exam {
      grid-template-columns: min-content auto;
      grid-column-gap: 1rem;
    }
    .exam-bullet {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background-color ease 0.3s;
      border: 1px solid var(--text-color-dark);
    }
    input.input-exam {
      &:checked {
        + .exam-bullet {
          background-color: var(--primary-color);
          color: var(--white-color);
          border: 2px solid var(--white-color);
          outline: 1px solid var(--primary-color);
        }
      }
    }
    div.question-container {
      user-select: none;
      border-top: 1px solid var(--primary-color);
      padding: 15px 50px 15px 10px;
      overflow: auto;
      position: relative;
      &:first-child {
        border: none;
      }
      @media screen and (max-width: 768px) {
        padding: 15px 25px 15px 0;
        p {
          font-size: var(--font-size-sm);
        }
      }
      div.quiz-answer-container img {
        max-width: 150px;
      }
    }
    .check-is-false-exam input.input-exam:checked {
      + .exam-bullet {
        background-color: var(--danger-color);
        outline: 2px solid var(--danger-color);
      }
    }

    .check-is-true-exam input.input-exam:checked {
      + .exam-bullet {
        background-color: var(--success-color);
        outline: 2px solid var(--success-color);
      }
    }
  }
`;
